import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Avatar from '~/Common-Objects/Avatar/Avatar'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import ButtonSelect from '~/Common-Objects/UI/Forms/ButtonSelect/ButtonSelect'
import Icons from '~/Common-Objects/UI/Icons/index'
import Score from '~/Common-Objects/UI/Score'
import Tags from '~/Common-Objects/Tags/Tags'
import { alterSiteDrawer, alterSnackbar } from '../../../data/actions/siteActions'
import axios from '../../../data/http/axios'
import ReactMapboxGl, { Marker } from 'react-mapbox-gl'
import DateTimeFunctions from '../../../Classes/dateTimeFunctions'
import i18n from '~/i18n'

const Map = ReactMapboxGl({
    accessToken:
        'pk.eyJ1IjoiY29udGFjdGdhdGUiLCJhIjoiODI5ZDJlOWNiNGM5YTM4OGM1Mzk2ODA2MjI4MTI2YmQifQ.iEJBZeGfK-7O2nOkPxIBDA'
})

export default function ContactDetails({ SubscriberId, stats }) {
    const [contact, setContact] = useState(null)
    const siteMaster = useSelector((state) => state.siteMaster)
    const dispatch = useDispatch()

    const getContact = async () => {
        let contactData = await axios.get('/subscriber/' + SubscriberId)
        contactData = contactData.data.Subscriber
        setContact(contactData)
    }

    const changeStatus = async (status) => {
        dispatch(
            alterSiteDrawer(
                true,
                true,
                'right',
                <ConfirmStatusChange status={status} subId={SubscriberId} onFinish={getContact} />
            )
        )
    }

    const tagsChanged = async (newTags) => {
        await axios.put(`/subscriber/${SubscriberId}/tags`, { tags: newTags.map((tag) => tag.id) })
        await getContact()
    }

    useEffect(() => {
        getContact()
    }, [SubscriberId])

    if (!contact) return <div className='contact-details contact-details-loading'></div>

    let statusText = i18n.t('Active')
    let iconLeft = <Icons icon='tickCircle' color={siteMaster.colours['$status-green']} />
    let color = siteMaster.colours['$status-green']
    if (contact.blackListed) {
        statusText = i18n.t('Blacklisted')
        iconLeft = <Icons icon='warning' color='black' />
        color = 'black'
    } else if (contact.bounce) {
        statusText = i18n.t('Bounced')
        iconLeft = <Icons icon='warning' color={siteMaster.colours['$status-red']} />
        color = siteMaster.colours['$status-red']
    } else if (contact.GroupSubscribers.every((g) => g.unsubscribe)) {
        statusText = i18n.t('Unsubscribed')
        iconLeft = <Icons icon='questionCircle' color={siteMaster.colours['$status-orange']} />
        color = siteMaster.colours['$status-orange']
    } else if (contact.GroupSubscribers.some((g) => g.unsubscribe)) {
        statusText = i18n.t('UnsubscribedFromSome')
        iconLeft = <Icons icon='questionCircle' color={siteMaster.colours['$status-orange']} />
        color = siteMaster.colours['$status-orange']
    } else if (contact.GroupSubscribers.every((g) => !g.active)) {
        statusText = i18n.t('In-Active')
        iconLeft = <Icons icon='questionCircle' color={siteMaster.colours['$status-yellow']} />
        color = siteMaster.colours['$status-yellow']
    } else if (contact.GroupSubscribers.some((g) => !g.active)) {
        statusText = i18n.t('InActiveInSome')
        iconLeft = <Icons icon='questionCircle' color={siteMaster.colours['$status-yellow']} />
        color = siteMaster.colours['$status-yellow']
    }

    let mapStyle = {
        width: '100%',
        backgroundImage: 'url(https://cdn1.ourmailsender.com/siteContent/assets/misc/blankMap.jpg)',
        backgroundSize: 'cover'
    }
    let mapBg
    if (
        stats.geolocation &&
        stats.geolocation.longitude &&
        stats.geolocation.longitude &&
        stats.geolocation.longitude !== 51.5139573 &&
        stats.geolocation.longitude !== -0.1148677
    ) {
        mapStyle = undefined
        mapBg = (
            <Map
                style='mapbox://styles/contactgate/cl9mrlyyz001t16nuzmha2j4j'
                // style="mapbox://styles/contactgate/cjg3exzgh160u2rp1nkgnn4na"
                center={[stats.geolocation.longitude, stats.geolocation.latitude - 0.015]}
                id='mapHolder'
                zoom={[8]}
                containerStyle={{
                    height: 180,
                    width: '100%',
                    boxSizing: 'border-box',
                    borderRadius: 8
                }}
            >
                <Marker
                    coordinates={[stats.geolocation.longitude, stats.geolocation.latitude]}
                    longitude={stats.geolocation.longitude}
                    latitude={stats.geolocation.latitude}
                >
                    <Icons icon='radiobutton' color={color} />
                </Marker>
            </Map>
        )
    }

    return (
        <div className='contact-details'>
            <div className='contact-details-map' style={mapStyle}>
                {mapBg}
            </div>
            <div className='contact-details-data'>
                <div className='quickFlex' style={{ justifyContent: 'space-between', marginBottom: 12 }}>
                    <Avatar style={{ height: 60, width: 60 }} src={contact.subscriberImage} />
                    <ButtonSelect headerText={statusText} iconLeft={iconLeft}>
                        <ul>
                            <li>
                                <a onClick={() => changeStatus('active')}>{i18n.t('Active')}</a>
                            </li>
                            <li>
                                <a onClick={() => changeStatus('inactive')}>{i18n.t('In-Active')}</a>
                            </li>
                            <li>
                                <a onClick={() => changeStatus('unsubscribed')}>{i18n.t('Unsubscribed')}</a>
                            </li>
                            <li>
                                <a onClick={() => changeStatus('bounce')}>{i18n.t('Bounced')}</a>
                            </li>
                            <li>
                                <a onClick={() => changeStatus('blacklisted')}>{i18n.t('Blacklisted')}</a>
                            </li>
                        </ul>
                    </ButtonSelect>
                </div>
                <div style={{ marginBottom: 8 }}>
                    <Score score={contact.score} />
                </div>
                <div style={{ fontWeight: 600, fontSize: 18 }}>{contact.emailAddress}</div>
                <div style={{ marginBottom: 20 }}>
                    Added {DateTimeFunctions.formatDateTime(contact.createdAt)}
                    {contact.country && <> · Country: {contact.country}</>}
                </div>
                <Tags
                    tagsSelected={contact.Tags}
                    readOnly={contact.LinkTags}
                    tagsChanged={tagsChanged}
                    tagType={0}
                    addStyle={{}}
                />
            </div>
        </div>
    )
}

function ConfirmStatusChange({ status, subId, onFinish = () => {} }) {
    const dispatch = useDispatch()

    const confirm = async () => {
        await axios.put('/subscriber/' + subId + '/status', { status })
        dispatch(alterSnackbar(true, 'Status Updated'))
        dispatch(alterSiteDrawer(false, true, 'right', null))
        onFinish()
    }

    return (
        <div>
            <h4 className='mar-b25'>Change Contact Status</h4>
            <div className='mar-b25'>
                {status === 'active' && (
                    <div>
                        Changing a contact to active will make them active in all groups and available for emailing
                    </div>
                )}
                {status === 'inactive' && (
                    <div>
                        Changing a contact to in-active will make them in-active in all groups and not available for
                        emailing
                    </div>
                )}
                {status === 'unsubscribed' && (
                    <div>
                        Changing a contact to unsubscribed will make them unsubscribe them all from all groups and not
                        available for emailing
                    </div>
                )}
                {status === 'bounce' && <div>Change contact status to bounced and not available for emailing</div>}
                {status === 'blacklisted' && (
                    <div>Change contact status to Denylisted and not available for emailing</div>
                )}
            </div>
            <Button onClick={confirm}>Confirm</Button>
        </div>
    )
}
